<template>
  <div>
    <h3>{{ newspaper.title }}</h3>
    <form class="form">
      <div class="placeholder">
        <div class="message">{{ newspaper.firstname }} {{ error }}</div>
        <span class="text">{{ newspaper.firstname }}</span>
        <input
          @blur="outFocus($event)"
          @focus="onFocus($event)"
          ref="fName"
          v-model="fName"
          type="text"
          name="fname"
          autocomplete="fname"
        />
      </div>
      <div class="placeholder">
        <div class="message">{{ newspaper.lastname }} {{ error }}</div>
        <span class="text">{{ newspaper.lastname }}</span>
        <input
          @blur="outFocus($event)"
          @focus="onFocus($event)"
          ref="lName"
          v-model="lName"
          type="text"
          name="lname"
          autocomplete="lname"
        />
      </div>
      <div class="placeholder">
        <div class="message">{{ newspaper.email }} {{ error }}</div>
        <span class="text">{{ newspaper.email }}</span>
        <input
          @blur="outFocus($event)"
          @focus="onFocus($event)"
          ref="email"
          v-model="email"
          type="email"
          name="email"
          autocomplete="email"
        />
      </div>
      <button
        v-on:click="sendForm($event)"
        v-bind:class="{ 'is-loading': sending }"
        class="button normal"
      >
        <span>{{ newspaper.send }}</span>
      </button>
    </form>
    <div v-if="errorMessage" class="error">{{ newspaper.wrong }}</div>
    <div v-if="alreadyMessage" class="error">{{ newspaper.already }}</div>
    <div v-if="send" class="success">{{ newspaper.success }}</div>
  </div>
</template>

<script>
/* global wpApiSettings */
import axios from "axios";

export default {
  data() {
    return {
      api: wpApiSettings.root,
      newspaper: wpApiSettings.newspaper,
      fName: "",
      lName: "",
      email: "",
      sending: false,
      send: false,
      errorMessage: false,
      alreadyMessage: false,
      error: "",
    };
  },
  watch: {
    fName() {
      let parentFName = this.$refs.fName.parentElement;
      parentFName.classList.remove("error");
    },
    lName() {
      let parentLName = this.$refs.lName.parentElement;
      parentLName.classList.remove("error");
    },
    email() {
      let parentEmail = this.$refs.email.parentElement;
      parentEmail.classList.remove("error");
    },
  },
  methods: {
    onFocus(event) {
      let placeholder = event.target.parentElement;
      placeholder.classList.add("is-focus");
    },
    outFocus(event) {
      let placeholder = event.target.parentElement;
      let inputLength = event.target.value.length;
      if (inputLength === 0) {
        placeholder.classList.remove("is-focus");
      }
    },
    sendForm(event) {
      event.preventDefault();
      this.send = false;
      this.errorMessage = false;
      this.alreadyMessage = false;

      function emailIsValid(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      }

      let parentFName = this.$refs.fName.parentElement;
      let parentLName = this.$refs.lName.parentElement;
      let parentEmail = this.$refs.email.parentElement;

      if (!this.fName) {
        parentFName.classList.add("error");
        this.error = this.newspaper.error;
        this.$refs.fName.focus();
      } else if (!this.lName) {
        parentLName.classList.add("error");
        this.error = this.newspaper.error;
        this.$refs.lName.focus();
      } else if (!this.email) {
        parentEmail.classList.add("error");
        this.error = this.newspaper.error;
        this.$refs.email.focus();
      } else if (!emailIsValid(this.email)) {
        parentEmail.classList.add("error");
        this.error = this.newspaper.valid;
        this.$refs.email.focus();
      } else {
        this.sending = true;

        let bodyForm = new FormData();
        bodyForm.set("fname", this.fName);
        bodyForm.set("lname", this.lName);
        bodyForm.set("email", this.email);

        axios({
          method: "post",
          url: `${this.api}newspaper/v1/send/`,
          data: bodyForm,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        })
          .then((response) => {
            this.sending = false;
            if (response.data == "success") {
              this.send = true;
              this.fName = "";
              this.lName = "";
              this.email = "";
            } else if (response.data == "already") {
              this.alreadyMessage = true;
            } else {
              this.errorMessage = true;
            }
          })
          .catch((error) => {
            if (error) this.errorMessage = true;
          });
      }
    },
  },
};
</script>
